import Pageable from 'redpoints-connector-common/model/pageable/Pageable';

import { paginationToPageable } from 'redpoints-front-common/helpers';

import { NUM_ITEMS_PER_PAGE } from '../config/constants';

export const DEFAULT_PAGINATION_SIZE_OPTIONS = ['10', '20', '40'];

const paginationShowTotal = (totalItems, range) =>
  `${range[0]} - ${range[1]} of ${totalItems >= 5000 ? '≥ 5000' : totalItems}`;

export const getPaginationObject = (overrides = {}) => ({
  hidePageNumbers: true,
  showSizeChanger: true,
  showTotal: paginationShowTotal,
  pageSizeOptions: DEFAULT_PAGINATION_SIZE_OPTIONS,
  current: 1,
  pageSize: NUM_ITEMS_PER_PAGE,
  ...overrides,
});

/**
 *
 * @param {Pageable} pageable
 */
export const defaultSorting = pageable => ({
  columnKey: pageable.order[0].property,
  setSorting: pageable.order[0].direction.value,
});

export const buildPageable = ({ columnKey, current, order, pageSize } = {}) => {
  if (order) {
    return paginationToPageable({
      current,
      order,
      pageSize,
      sortProperty: columnKey,
    });
  }

  const DEFAULT_PAGE_SIZE = 10;
  const pageable = new Pageable();
  pageable.size = pageSize || DEFAULT_PAGE_SIZE;
  pageable.page = current - 1 || 0;

  return pageable;
};
